import React, { Component, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Modal } from '../../../UiKit';
import { RiderAssignments } from '../../popups';
import { valetModel } from '../../../api';
import './Valet.scss';
import { ValetInfo } from './ValetInfo';
import {
  sendValetApiEvents,
  VALET_EVENTS,
} from '../../../helpers/analytics/valet.analytics';

export default class Valet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valet: null,
    };
    this.timer = null;
  }

  componentDidMount() {
    this.getValetInfo();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  startPolling = (time) => {
    const { orderId, userId } = this.props;
    const pollingTime = time || 60;
    if (this.timer) {
      this.stopPolling();
    }
    this.timer = setTimeout(() => {
      sendValetApiEvents(
        VALET_EVENTS.VALET_POLLING_START_EVENT,
        orderId,
        userId,
      );
      this.getValetInfo(true);
    }, pollingTime * 1000);
  };

  stopPolling = () => {
    const { orderId, userId } = this.props;
    sendValetApiEvents(VALET_EVENTS.VALET_POLLING_STOP_EVENT, orderId, userId);
    clearTimeout(this.timer);
  };

  getValetInfo = (isPolling = false) => {
    const { orderId, userId } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    if (isPolling) {
      queryStrings['is_polling'] = isPolling;
    }
    valetModel
      .getValetData(queryStrings)
      .then((response) => {
        if (!response || (response && response.isError === true)) return null;
        sendValetApiEvents(
          VALET_EVENTS.GET_VALET_DETAILS_SUCCESS,
          orderId,
          userId,
        );
        this.setState({
          valet: { ...response },
        });
        if (response?.polling_enabled) {
          this.startPolling(response?.polling_time);
        } else {
          this.stopPolling();
        }
      })
      .catch(() => {
        sendValetApiEvents(
          VALET_EVENTS.GET_VALET_DETAILS_FAILURE,
          orderId,
          userId,
        );
      });
  };

  render() {
    const { valet } = this.state;
    return (
      <div className='valetContainer'>
        {!valet ? (
          <Shimmer height='150px' width='220px' />
        ) : (
          <ValetComponent {...this.props} valet={valet} />
        )}
      </div>
    );
  }
}

function ValetComponent(props) {
  const [modalState, setModalState] = useState({
    showPopup: false,
    modalComp: null,
    modalHeaderText: '',
  });

  const getAssignments = (assignments) => {
    setModalState({
      showPopup: true,
      modalHeaderText:
        assignments?.label || 'Delivery Partner Assignments History',
      modalComp: (
        <RiderAssignments
          data={assignments}
          orderId={orderId}
          userId={userId}
          cartId={orderBasicInfo?.order?.cart_id}
        />
      ),
    });
  };

  const closePopup = () => {
    // const { orderId, userId } = props;
    // sendValetApiEvents(VALET_EVENTS.VALET_MODAL_CLOSE, orderId, userId);
    setModalState({
      showPopup: false,
      modalComp: null,
    });
  };

  const {
    valet,
    isShowCalls = true,
    orderId,
    userId,
    isWFH,
    orderBasicInfo,
  } = props;
  const { showPopup, modalComp, modalHeaderText } = modalState;
  const valetTitle = valet?.label || 'Delivery Partner';
  const valetName = valet?.name;
  const valetId = valet?.driver_fe_id;
  let comp = null;

  if (valetName != undefined) {
    comp = (
      <ValetInfo
        valetTitle={valetTitle}
        valet={valet}
        orderId={orderId}
        valetId={valetId}
        getAssignments={getAssignments}
        userId={userId}
        isWFH={isWFH}
        orderBasicInfo={orderBasicInfo}
      />
    );
  } else if (!isShowCalls) {
    comp = (
      <ValetInfo
        valetTitle={valetTitle}
        getAssignments={getAssignments}
        orderId={orderId}
        userId={userId}
        valetId={valetId}
        noData={true}
        orderBasicInfo={orderBasicInfo}
      />
    );
  }

  return (
    <React.Fragment>
      <div className='valetInfo'>{comp}</div>
      <Modal
        isVisible={showPopup}
        title={modalHeaderText}
        type='huge'
        handleClose={closePopup}
        component={modalComp}
      />
    </React.Fragment>
  );
}
